module.exports = __webpack_public_path__ + "img/tab-stores-active.02b53bda.svg";